import React from "react"
import {
  ImageListViewMobile,
  ImageGridViewMobile,
  ListViewSelected,
  GridViewUnSelected,
} from "@/components/PartsViewer/v2/icon.js"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"

const ToggleView = props => {
  const { listView, setlistView, device } = props || {}
  const isDesktop = device.isExtraLargeScreen || device.isLargeScreen
  const { t } = useTranslation("common")
  const { gridViewText, listViewText } = getTranslations(t)
  return (
    <>
      <div className="btn-group btn-group-toggle" data-toggle="buttons">
        <button
          className={`btn-expand grid-btn border-0 ${
            isDesktop || device?.isMediumScreen ? "pr-15" : "pr-15 pl-20"
          } ${listView ? "" : "active"}`}
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            setlistView(false)
          }}
          data-testid="select-grid-view"
        >
          {!listView ? <ImageGridViewMobile /> : <GridViewUnSelected />}
          {isDesktop ? (
            <span className="tool-tip-custom bottom grid-list-view">
              {gridViewText}
            </span>
          ) : null}
        </button>

        <button
          className={`btn-expand list-btn border-0 ${listView ? "active" : ""}`}
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            setlistView(true)
          }}
        >
          {listView ? <ListViewSelected /> : <ImageListViewMobile />}
          {isDesktop ? (
            <span className="tool-tip-custom bottom grid-list-view">
              {listViewText}
            </span>
          ) : null}
        </button>
      </div>
    </>
  )
}

export default ToggleView
